<svg
  width="47"
  height="46"
  viewBox="0 0 47 46"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_852_45105)">
    <path
      d="M23.3143 6.40967C12.3444 6.40967 3.45166 15.2073 3.45166 26.0645C3.45166 36.9168 12.3444 45.7187 23.3143 45.7187C34.2841 45.7187 43.1762 36.9168 43.1769 26.0652C43.1776 15.208 34.2841 6.40967 23.3143 6.40967Z"
      fill="url(#paint0_linear_852_45105)"
    />
    <path
      d="M3.95166 26.0645C3.95166 15.4884 12.6156 6.90967 23.3143 6.90967C34.013 6.90967 42.6776 15.4891 42.6769 26.0652C42.6762 36.6357 34.0129 45.2187 23.3143 45.2187C12.6156 45.2187 3.95166 36.6357 3.95166 26.0645Z"
      stroke="#774700"
      stroke-opacity="0.5"
    />
    <path
      d="M34.0821 24.9233C31.2524 21.3047 29.2774 21.3047 26.447 24.9233C26.0186 25.4701 25.1411 25.063 25.3241 24.5323C27.7253 17.5387 32.8045 17.5387 35.2071 24.5323C35.388 25.063 34.5105 25.4701 34.0821 24.9233Z"
      fill="#1A1626"
    />
    <path
      d="M20.1785 24.9228C17.3488 21.3042 15.3739 21.3042 12.5442 24.9228C12.115 25.4697 11.2375 25.0625 11.4205 24.5318C13.8218 17.5382 18.9009 17.5382 21.3022 24.5318C21.4852 25.0625 20.6077 25.4697 20.1785 24.9228Z"
      fill="#1A1626"
    />
    <path
      opacity="0.6"
      d="M12.3086 39.3937C16.2515 39.3937 19.4478 36.2308 19.4478 32.3292C19.4478 28.4275 16.2515 25.2646 12.3086 25.2646C8.36576 25.2646 5.16943 28.4275 5.16943 32.3292C5.16943 36.2308 8.36576 39.3937 12.3086 39.3937Z"
      fill="url(#paint1_radial_852_45105)"
    />
    <path
      opacity="0.6"
      d="M34.1292 39.3937C38.072 39.3937 41.2684 36.2308 41.2684 32.3292C41.2684 28.4275 38.072 25.2646 34.1292 25.2646C30.1863 25.2646 26.99 28.4275 26.99 32.3292C26.99 36.2308 30.1863 39.3937 34.1292 39.3937Z"
      fill="url(#paint2_radial_852_45105)"
    />
    <path
      d="M7.00151 39.0753C7.00151 39.0753 5.77783 37.22 4.33566 35.2503C3.24605 33.7629 -0.153294 35.9699 0.766061 38.7229C1.29384 40.2981 2.74665 44.307 5.97291 42.8498C6.62412 41.6354 5.91474 41.1138 7.00151 39.0753Z"
      fill="#A6E639"
    />
    <path
      d="M8.05007 41.7969C12.8816 39.9641 19.1611 37.5767 19.8619 37.3247C20.2805 37.1752 19.7889 34.4453 19.137 34.6622C18.302 34.938 12.085 37.0804 7.32153 38.7384L8.05007 41.7969Z"
      fill="#75D6FF"
    />
    <path
      opacity="0.5"
      d="M18.153 37.9631C18.8539 37.6998 19.3888 37.4984 19.6775 37.3938C18.7851 36.7262 17.8963 36.06 17.0039 35.396C16.5357 35.5589 16.0086 35.7386 15.439 35.9372C16.347 36.6069 17.2514 37.2843 18.153 37.9631Z"
      fill="#0FB4D4"
    />
    <path
      opacity="0.5"
      d="M14.6032 39.3056C15.17 39.0901 15.7127 38.8859 16.2213 38.6942L13.4555 36.627C12.9135 36.8137 12.3538 37.0109 11.7913 37.2026L14.6032 39.3056Z"
      fill="#0FB4D4"
    />
    <path
      opacity="0.5"
      d="M11.0914 40.6335C11.4071 40.5142 12.3853 40.147 12.6981 40.0291L9.81948 37.8755C9.49104 37.9892 8.58871 38.3002 8.26807 38.4132L11.0914 40.6335Z"
      fill="#0FB4D4"
    />
    <path
      d="M8.49952 41.73C8.84428 41.5889 8.16399 38.3241 7.79369 38.4385C7.54612 38.515 5.77905 39.0745 5.77905 39.0745L5.91171 42.8117C5.911 42.8131 8.3087 41.81 8.49952 41.73Z"
      fill="#7AB51D"
    />
    <path
      d="M3.10592 42.252C1.23245 40.9183 4.89568 36.8477 6.72943 38.6615C8.15031 40.0661 5.16312 43.7184 3.10592 42.252Z"
      fill="#7AB51D"
    />
    <path
      d="M3.903 41.8363C2.51191 40.8479 5.2338 37.819 6.59652 39.1682C7.65278 40.2127 5.43314 42.9271 3.903 41.8363Z"
      fill="#529320"
    />
    <path
      d="M4.68974 41.49C3.81933 40.8702 5.52255 38.9784 6.3738 39.8228C7.03424 40.4736 5.64669 42.1709 4.68974 41.49Z"
      fill="#297124"
    />
    <path
      d="M19.1904 37.4493C19.8473 36.5276 19.2819 35.2416 18.4945 35.0661C17.8979 34.9342 17.4063 33.8581 18.1199 32.7806C18.923 31.5683 21.1724 32.0962 22.4741 29.7832C22.8338 32.4773 19.7366 32.9146 19.5869 33.6826C19.4295 34.4884 20.5226 34.7299 20.8135 35.5568C21.0234 36.1535 20.2169 37.5735 20.983 37.9315C21.7009 38.2678 24.3079 36.979 25.6117 39.3685C23.1863 38.2467 21.7044 39.8331 20.3055 39.4562C18.5328 38.9789 18.9811 37.7441 19.1904 37.4493Z"
      fill="#1A1626"
    />
    <path
      d="M39.3226 0.793945L40.464 16.6842C39.5439 18.0797 22.3344 8.17364 23.2551 6.77885L39.3226 0.793945Z"
      fill="url(#paint3_linear_852_45105)"
    />
    <path
      d="M39.3221 0.794922L39.586 4.47178C39.586 4.47178 37.7281 3.6912 36.6633 1.78679L39.3221 0.794922Z"
      fill="url(#paint4_linear_852_45105)"
    />
    <path
      d="M28.3807 4.86816C33.5896 11.4757 40.4117 15.9872 40.4117 15.9872L40.4621 16.6828C40.167 17.1335 38.1942 16.4126 35.6844 15.1898C35.6844 15.1898 29.7335 12.1377 25.6091 5.89864L28.3807 4.86816Z"
      fill="url(#paint5_linear_852_45105)"
    />
    <path
      d="M33.9261 2.80371C36.9104 6.78312 39.8622 8.32251 39.8622 8.32251L40.1402 12.1742C40.1402 12.1742 34.756 9.11783 31.1538 3.83629L33.9261 2.80371Z"
      fill="url(#paint6_linear_852_45105)"
    />
    <path
      d="M42.7863 32.4773L42.0485 31.2573C42.0485 31.2573 43.7383 30.5392 44.4405 29.9454C41.962 28.9338 40.368 28.7899 42.6969 26.2453C37.9015 27.0449 40.102 24.68 41.7953 22.3761C40.6262 22.3123 40.7773 22.1648 40.6638 21.0108C44.6626 20.7392 43.0651 23.149 41.4129 25.0485C45.0847 24.4617 44.6881 25.7076 43.0069 28.1582C44.4583 28.4719 46.0281 29.2315 46.0111 30.0956C45.9934 31.0748 42.7863 32.4773 42.7863 32.4773Z"
      fill="#E81C27"
    />
    <path
      d="M12.7953 5.94444L8.17651 6.74257L10.0294 2.2002L12.7953 5.94444Z"
      fill="#E635DE"
    />
    <path
      d="M39.9438 33.2207L36.387 33.4173L38.1938 30.1553L39.9438 33.2207Z"
      fill="#A6E639"
    />
    <path
      d="M7.47484 11.6057L5.7624 14.5336L2.85962 12.7429L4.57703 9.81641L7.47484 11.6057Z"
      fill="#E81C27"
    />
    <path
      d="M19.9087 11.7568L17.3983 14.0276L16.22 10.8681L18.7347 8.59375L19.9087 11.7568Z"
      fill="#0FB4D4"
    />
    <path
      d="M40.9513 39.4861L39.5013 42.8106L36.3928 40.9012L37.8428 37.5732L40.9513 39.4861Z"
      fill="#E635DE"
    />
    <path
      d="M45.0739 11.3096C45.0739 13.8149 41.2773 13.8149 41.2773 11.3096C41.2773 8.805 45.0739 8.805 45.0739 11.3096Z"
      fill="#A6E639"
    />
    <path
      d="M7.09321 22.0532C7.09321 24.5592 3.2959 24.5592 3.2959 22.0532C3.2959 19.5487 7.09321 19.5487 7.09321 22.0532Z"
      fill="#0FB4D4"
    />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_852_45105"
      x1="23.3143"
      y1="45.7187"
      x2="23.3143"
      y2="6.40967"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FF7B00" />
      <stop offset="0.3236" stop-color="#FFAE00" />
      <stop offset="0.6205" stop-color="#FFD600" />
      <stop offset="0.8558" stop-color="#FFEE00" />
      <stop offset="1" stop-color="#FFF700" />
    </linearGradient>
    <radialGradient
      id="paint1_radial_852_45105"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(12.3085 32.329) scale(7.13933 7.06466)"
    >
      <stop offset="0.1" stop-color="#FF6399" />
      <stop offset="0.2515" stop-color="#FF6795" stop-opacity="0.8316" />
      <stop offset="0.4086" stop-color="#FF7489" stop-opacity="0.6571" />
      <stop offset="0.5682" stop-color="#FF8875" stop-opacity="0.4798" />
      <stop offset="0.7296" stop-color="#FFA55A" stop-opacity="0.3005" />
      <stop offset="0.8907" stop-color="#FFCA36" stop-opacity="0.1215" />
      <stop offset="1" stop-color="#FFE81A" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="paint2_radial_852_45105"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(34.1292 32.329) scale(7.13955 7.06487)"
    >
      <stop offset="0.1" stop-color="#FF6399" />
      <stop offset="0.2515" stop-color="#FF6795" stop-opacity="0.8316" />
      <stop offset="0.4086" stop-color="#FF7489" stop-opacity="0.6571" />
      <stop offset="0.5682" stop-color="#FF8875" stop-opacity="0.4798" />
      <stop offset="0.7296" stop-color="#FFA55A" stop-opacity="0.3005" />
      <stop offset="0.8907" stop-color="#FFCA36" stop-opacity="0.1215" />
      <stop offset="1" stop-color="#FFE81A" stop-opacity="0" />
    </radialGradient>
    <linearGradient
      id="paint3_linear_852_45105"
      x1="26.6794"
      y1="2.01551"
      x2="42.7207"
      y2="13.5455"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.1152" stop-color="#75D6FF" />
      <stop offset="0.2815" stop-color="#71D2FB" />
      <stop offset="0.4615" stop-color="#64C5EE" />
      <stop offset="0.648" stop-color="#4EB0DA" />
      <stop offset="0.8377" stop-color="#3093BD" />
      <stop offset="1" stop-color="#10749E" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_852_45105"
      x1="37.0182"
      y1="1.28608"
      x2="40.218"
      y2="3.58588"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.1758" stop-color="#E84D88" />
      <stop offset="0.359" stop-color="#E34883" />
      <stop offset="0.5884" stop-color="#D53874" />
      <stop offset="0.8415" stop-color="#BF1F5B" />
      <stop offset="1" stop-color="#AD0B48" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_852_45105"
      x1="25.3254"
      y1="6.2923"
      x2="40.2302"
      y2="17.0055"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.1758" stop-color="#E84D88" />
      <stop offset="0.359" stop-color="#E34883" />
      <stop offset="0.5884" stop-color="#D53874" />
      <stop offset="0.8415" stop-color="#BF1F5B" />
      <stop offset="1" stop-color="#AD0B48" />
    </linearGradient>
    <linearGradient
      id="paint6_linear_852_45105"
      x1="30.9611"
      y1="4.10411"
      x2="40.838"
      y2="11.2033"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.1758" stop-color="#E84D88" />
      <stop offset="0.359" stop-color="#E34883" />
      <stop offset="0.5884" stop-color="#D53874" />
      <stop offset="0.8415" stop-color="#BF1F5B" />
      <stop offset="1" stop-color="#AD0B48" />
    </linearGradient>
    <clipPath id="clip0_852_45105">
      <rect
        width="45.4003"
        height="44.9254"
        fill="white"
        transform="translate(0.609863 0.793457)"
      />
    </clipPath>
  </defs>
</svg>
